class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.navigation = document.querySelector('.header__inline-menu');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.navigation.classList.add('modal-search-open')

    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    if (this.lottieAnimationMobile) {
      this.lottieAnimationMobile.stop();
      var that = this;
      setTimeout(() => { 
        if (document.body.clientWidth <= 990) {
          that.lottieAnimationMobile.play();
        }
      }, 500); 
    }

    if (this.lottieAnimationMobile_Header && document.body.clientWidth <= 900) {
      this.lottieAnimationMobile_Header.stop();
      const that = this;
      setTimeout(() => that.lottieAnimationMobile_Header.play(), 500);
    }

    if (this.lottieAnimationDesktop) {
      this.lottieAnimationDesktop.stop();
      var that = this;
      setTimeout(() => { 
        if (document.body.clientWidth > 990) {
          that.lottieAnimationDesktop.play();
        }
      }, 500);
    }
  }

  close(focusToggle = true) {
    this.navigation.classList.remove('modal-search-open')
    
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
